const styles = theme => ({
  box: {
    width: 20,
    height: 20,
  },
  typography: {
    fontSize: '24px',
    fontWeight: '600',
    width: '240px',
  },
  caption: {
    color: theme.palette.text.secondary,
    minHeight: 25,
    marginTop: 10,
  },
  boxRoot: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 1,
  },

  rootHeader: {
    width: 300,
    height: 36,
    display: 'flex',
  },
  contentStyle: {
    margin: 'auto',
    display: 'flex',
    flexDirection: 'column',
    width: 60,
    height: 20,
    backgroundColor: 'rgba(1, 95, 251, 0.08)',
    color: '#015FFB',
    fontSize: '12px',
    textAlign: 'center',
    borderRadius: 5,
  },
  stackList: {
    my: 5,
    marginTop: 20,
    marginBottom: 20,
  },
  dollarText: {
    color: theme.palette.text.secondary,
    marginTop: 20,
  },
  priceValue: {
    fontSize: 48,
    fontWeight: 600,
  },
  listItemText: {
    color: '#002E47',
  },
  flexGrow: {
    flexGrow: 1,
  },
  box2: {
    width: 20,
    height: 20,
  },
  typography2: {
    color: '#002E47',
    flex: '1 0 0',
  },
  stack: {
    typography: 'body2',
    color: '#015FFB',
  },
  buttonStyle: {
    background: 'rgba(0, 46, 71, 0.08)',
  },
})

export default styles
